<template>
  <div>
    <common-table :url="url"
                  :table-columns="tableColumns"
                  :form-fields="formFields"
                  :operate="operate"
                  :permission="permission"
                  :searchs="searchs"
                  :buttons="buttons"
                  :auto-update="true"
                  ref="table">
    </common-table>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "UsdtTransferEnergyConfig",
  components: {CommonTable},
  data() {
    return {
      form: {
        startTime: '',
        endTime: '',
        agentId: '',
      },
      agents: [],
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        }
      ],
      permission:{
        add: 'usdtTransferEnergyConfig:add',
        update: 'usdtTransferEnergyConfig:update',
        delete: 'usdtTransferEnergyConfig:delete',
        deleteBatch: 'usdtTransferEnergyConfig:deleteBatch'
      },
      url: {
        get: '/usdtTransferEnergyConfig/listByCondition',
        add: '/usdtTransferEnergyConfig/add',
        update: '/usdtTransferEnergyConfig/update',
        delete: '/usdtTransferEnergyConfig/delete/',
        delete_batch: '/usdtTransferEnergyConfig/deleteBatch',
        status: '/usdtTransferEnergyConfig/update'
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      } ,{
        field: 'address',
        label: '转账地址',
        show: true,
        detail: false,
        width: ''
      }, {
        field: 'amount',
        label: '转账金额',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        detail: false,
        width: ''
      }],
      formFields: {
        addTitle: '添加账户',
        updateTitle: '修改账户',
        labelWidth: '90px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'address',
          label: '转账地址：',
          type: 'input',
          placeholder: '转账地址',
          rules:[{
            message: '请输入转账地址', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'amount',
          label: '转账金额：',
          type: 'input',
          placeholder: '转账金额',
          rules:[{
            message: '请输入转账金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }]
      },
      operate: [],
      buttons: []
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
